export default {
  adminURL: import.meta.env.VITE_ADMIN_URL,
  api: {
    baseURL: import.meta.env.VITE_API_URL
  },
  storage: {
    // Matched exactly to what is in your .env file
    key: import.meta.env.VITE_SESSION_KEY, 
    frequency: import.meta.env.VITE_SESSION_FREQUENCY
  },
  gtm: {
    auth: import.meta.env.VITE_GTM_AUTH,
    env: import.meta.env.VITE_GTM_ENV
  }
}
